import React, {useEffect} from 'react'
import AppContainer from "../components/container/AppContainer";
import {MainTitleContainer, Margin25} from "../styles/GlobalStyles";
import Text from "../components/text/Text";
import Button from "../components/button/Button";
import NavigationService from "../services/NavigationService";
import styled from "@emotion/styled";
import {GAEvent, GAPageView} from "../services/AnalyticsService";

const NoMatch = () => {
    const navigateToHome = () => {
        GAEvent("Navigation", "NoMatch Button click", "Button")
        NavigationService.navigate("/", "Accueil")
        window.dispatchEvent(new Event("location change"))
    }

    useEffect(() => {
        GAPageView("NoMatch")
    }, []);

    return (
        <AppContainer>
            <MainContainer>
                <MainTitleContainer>
                    <Text type={"h4"}>
                        Désolé la page demandée n'existe pas !
                    </Text>
                </MainTitleContainer>

                <Margin25 />

                <Button onClick={navigateToHome} >
                    Retourner à l'accueil
                </Button>
            </MainContainer>
        </AppContainer>
    )
}

export default NoMatch

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 150px);
  width: 100%;
`
